import type { DB } from '@/types/common';
import type { PersonTitle } from '@/types/person';

export enum ContactActiveProposalStatus {
	NOT_CONCERNED = 'NOT_CONCERNED',
	CONCERNED = 'CONCERNED',
	NO_RECEIVE = 'NO_RECEIVE',
}

export enum EContactType {
	DECISION_MAKER = 'decision-maker',
	PRESCRIBER = 'prescriber',
	HR = 'hr',
	ACCOUNTANT = 'accountant',
	QHSE = 'qhse',
	UNIQUE_CONTACT = 'unique-contact',
}

export interface Contact extends Partial<DB> {
	salesforceId: string;
	firstname: string;
	lastname: string;
	middlename?: string;
	civility: PersonTitle;
	email: string;
	phone: string;
	otherPhone: string;
	companiesList: string[];
	job: string;
	service: string;
	description?: string;
	role: EContactType;
	activeProposalStatus: ContactActiveProposalStatus;
	jobIds?: string[];
}
